import Model, { AsyncBelongsTo, attr, belongsTo } from '@ember-data/model';
import { dependentKeyCompat } from '@ember/object/compat';
import config from 'admin-panel/config/environment';

import type HotelModel from 'admin-panel/models/hotel';

export default class ImageModel extends Model {
  @belongsTo('hotel')
  declare hotel: AsyncBelongsTo<HotelModel>;

  @attr
  declare tags: string[];

  @attr
  declare uid?: string;

  @attr
  declare versions: {
    preview?: string;
    content_large?: string;
  } | null;

  @dependentKeyCompat
  get previewUrl() {
    return this.getVersionUrl('preview');
  }

  @dependentKeyCompat
  get contentLargeUrl() {
    return this.getVersionUrl('contentLarge') || this.previewUrl;
  }

  getVersionUrl(version: 'preview' | 'contentLarge') {
    const versionPath =
      version === 'contentLarge'
        ? this.versions?.content_large
        : this.versions?.preview;

    return versionPath ? new URL(versionPath, config.api.host).href : '';
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    image: ImageModel;
  }
}
